import { getGodModeOptionsState } from '@mote/helpers/identity'
import { useGenericRequestHandler } from '../../../handlers'

export const useAccountListUsersMutation = institutionId => {
  const godModeState = getGodModeOptionsState(institutionId)
  return useGenericRequestHandler({
    route: 't/listUsers',
    method: 'POST',
    options: {
      json: godModeState.options,
      shouldNotStoreAuthData: godModeState.inGodMode
    }
  })
}
